import appGlobalScript from 'F:/jackery-work/jackery-ui/packages/core/src/global/init.ts';
export const globalScripts = appGlobalScript;
